module.exports = {
  BASE_URL: 'https://cms.nzuac.com/api/',
  MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s',
  BULL: '/images/static/vector-1.svg',
  VECTOR2: '/images/static/vector-2.svg',
  VECTOR3: '/images/static/vector-3.svg',
  BLUR: '/images/static/blurbg.svg',
};
